export default __webpack_public_path__ + "images/bad21f2e8c4892f31bb2f6847badfd79-ballet_small.webp";